import { Injectable } from '@angular/core';
import { ViewModel } from '@farris/devkit';

/**
 * UIç¶ææå¡
 * @scope FrameComponent
 */
@Injectable()
class UIStateService {
  constructor(private viewModel: ViewModel) {
  }

  getState(componentId: string, stateName: string) {
    throw new Error('Not Implemented');
  }

  setState(componentId: string, propertyName: string, value: any) {
    const frameContext = this.viewModel.frameContext;
    const targetFrameContext = frameContext.appContext.frameContextManager.getFrameContextById(componentId);
    if (!targetFrameContext) {
      return;
    }
    const targetViewModel = targetFrameContext.viewModel;
    const targetUIState = targetViewModel.uiState;
    targetUIState.setPropertyValue(propertyName, value);
  }
}

export { UIStateService };
